// Copyright (c) StrangeBee 2023

import { CaseStatusStage, SearchFormInterface } from 'thehive-sdk';

export const similarityFilters: Record<string, { label: string; filters: SearchFormInterface[] }> = {
    none: {
        label: 'None',
        filters: [],
    },
    'open-cases': {
        label: 'Open Cases',
        filters: [
            {
                field: 'stage',
                operator: 'not',
                type: 'enumeration',
                values: [CaseStatusStage.CLOSED],
                describeAttribute: '' as any,
            },
        ],
    },
    'open-cases-last-7days': {
        label: 'Open Cases in the last 7 days',
        filters: [
            {
                field: 'stage',
                operator: 'not',
                type: 'enumeration',
                values: [CaseStatusStage.CLOSED],
                describeAttribute: '' as any,
            },
            {
                field: '_createdAt',
                type: 'date',
                operator: 'last7days',
                values: [],
                describeAttribute: '' as any,
            },
        ],
    },
    'open-cases-last-30days': {
        label: 'Open Cases in the last 30 days',
        filters: [
            {
                field: 'stage',
                operator: 'not',
                type: 'enumeration',
                values: [CaseStatusStage.CLOSED],
                describeAttribute: '' as any,
            },
            {
                field: '_createdAt',
                type: 'date',
                operator: 'last30days',
                values: [],
                describeAttribute: '' as any,
            },
        ],
    },
    'open-cases-last-3months': {
        label: 'Open Cases in the last 3 months',
        filters: [
            {
                field: 'stage',
                operator: 'not',
                type: 'enumeration',
                values: [CaseStatusStage.CLOSED],
                describeAttribute: '' as any,
            },
            {
                field: '_createdAt',
                type: 'date',
                operator: 'last3months',
                values: [],
                describeAttribute: '' as any,
            },
        ],
    },
    'open-cases-last-year': {
        label: 'Open Cases in the last year',
        filters: [
            {
                field: 'stage',
                operator: 'not',
                type: 'enumeration',
                values: [CaseStatusStage.CLOSED],
                describeAttribute: '' as any,
            },
            {
                field: '_createdAt',
                type: 'date',
                operator: 'lastyear',
                values: [],
                describeAttribute: '' as any,
            },
        ],
    },
    'resolved-cases': {
        label: 'Resolved cases',
        filters: [
            {
                field: 'stage',
                operator: 'eq',
                type: 'enumeration',
                values: [CaseStatusStage.CLOSED],
                describeAttribute: '' as any,
            },
        ],
    },
};
